// extracted by mini-css-extract-plugin
module.exports = {"Container":"SideMenuItemView_Container__47_DI","TitleText":"SideMenuItemView_TitleText__U0fyO"};